// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ABpog","toggleWrap":"styles_toggleWrap__2O81e","content":"styles_content__2R8pT","selectAreaCode":"styles_selectAreaCode__2QpM6"};